import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
export const Fact = ({ Icon, label, splitValue, value }) => {
    return (_jsx(Box, { flex: "1 0 auto", children: _jsxs(Box, { display: "flex", alignItems: "center", gap: "spacing.12", children: [Icon, _jsxs(Box, { display: "flex", flexDirection: "column", children: [_jsx(Box, { as: "span", typography: "typography.body.16.bold", children: splitValue || value }), _jsx(Box, { as: "span", typography: {
                                "breakpoint.base": "typography.body.12.regular",
                                "breakpoint.sm": "typography.body.14.regular",
                            }, color: "color.content.light.default", children: label })] })] }) }));
};
